import BaseProcessor from './BaseProcessor';
import store from '@/store';
import { getMessageLangParameter, messageCodes } from '@/models/MessageCodes';
import { logEvent } from '@/helpers/cieloLogger';
import Swal from 'sweetalert2';

export default class ClickToPayProcessor extends BaseProcessor {
    constructor(multiLanguage) {
        super(multiLanguage);
    }

    /**
     * Processa a transação de cartões Click To Pay
     */
    async ProcessTransaction() {
        super.BuildContract({
            ...store.getters['cardPayment/getSubmitModel'],
            ...store.getters['clickToPayPayment/getSubmitModel'],
        });

        let response = await super.SendTransactionRequest();

        if (response && response.MessageCodes && response.MessageCodes && response.MessageCodes[0] == messageCodes.CVV_REQUIRED) {
            throw Error(getMessageLangParameter(messageCodes.CVV_REQUIRED));
        }

        if (super.ResponseIsSuccess(response) == false) return;

        store.dispatch('preorder/setTransactionAsFinalized');

        // Redireciona para a url do merchant caso solicitado
        if (response.Data.Redirect && response.Data.Url)
            return window.location.href = response.Data.Url;

        store.dispatch('pipelineV2/pushToOrderStatus', response.Data.OrderId);
    }

    /**
     * Trata uma resposta especifica para Click To Pay.
     * @param {Object} response Reposta da api
     */
    HandleSuccessTransaction(response) {
        if (!response)
            return this.ShowUnexpectedError();

        if (response.Success) {
            store.commit('preorder/setTransactionSuccessfulResponse', response.Data);

            return response;
        }

        const shoudHandleErrorOutside = response.MessageCodes && response.MessageCodes[0] == messageCodes.CVV_REQUIRED;
        if (shoudHandleErrorOutside) {
            return response;
        }

        let errorMessage = this.multiLanguage
            .get(getMessageLangParameter(response.MessageCodes[0]));

        Swal.fire({
            type: 'error',
            title: 'Oppsss!',
            text: errorMessage || this.multiLanguage.get('unexpectedError')
        });

        logEvent({
            category: 'click to pay',
            action: 'resumo_compra_error_c2p',
            label: `[ERROR]: ${response.Message || this.multiLanguage.get('withoutMessage')}`
        });
    }
}
